import React, { FunctionComponent } from 'react';

import { StyledInformationCard, StyledInformationCardProps } from './information-card.styled';

type Props = StyledInformationCardProps & React.HTMLAttributes<HTMLDivElement>;

export const InformationCard: FunctionComponent<Props> = (props) => <StyledInformationCard {...props} />;
